import React from "react"
import { ButtonProps } from "@chakra-ui/react"
import Button from "./Button"

type Props = {
  onClick: () => void
  size?: ButtonProps["size"]
  isDisabled?: boolean
}

const CancelButton = ({
  onClick, size = "md", isDisabled,
}: Props) => (
  <Button
    variant="outline"
    colorScheme="button.light"
    onClick={onClick}
    size={size}
    isDisabled={isDisabled}
  >
    Cancel
  </Button>
)

export default CancelButton
